const state = {
  user: null,
  avatar: null
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
  }
};

const actions = {
  loadStoredUser({ commit }) {
    const user = localStorage.getItem("objs");
    const avatar = localStorage.getItem("avatar");

    if (user) {
      commit("setUser", JSON.parse(user));
    }

    if (avatar) {
      // กันกรณีที่ไม่มี prefix
      let fixed = avatar.startsWith("data:image")
        ? avatar
        : "data:image/jpeg;base64," + avatar;

      commit("setAvatar", fixed);
    }
  }
};

const getters = {
  user: state => state.user,
  avatar: state => state.avatar
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};